<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow"
        :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon">
          </svg-icon>
          <span class="onetxt" v-if="item.children[0].meta&&item.children[0].meta.title"
            slot="title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name" class="twotab">
        <template slot="title" class="twobox">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span class="towtxt" v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0"
            :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>



</template>

<script>
  export default {
    name: 'SidebarItem',
    props: {
      routes: {
        type: Array
      },
      isNest: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      hasOneShowingChildren(children) {
        const showingChildren = children.filter(item => {
          return !item.hidden
        })
        // const shows=showingChildren.filter(item => {
        //   return !item.alwaysShow
        // })
        // console.log(shows)
        if (showingChildren.length === 1) {
          return true
        }
        return false
      }
    }
  }
</script>
<style>
  *{
    font-size: 17px;
    /* margin-left: 15px; */
    font-weight: 500;
  }
  .twotab i::before{
    color: #FFFFFF;
  }

  .el-submenu {
    list-style: none;
    margin: 0;
    padding-left: 0px;
  }

  .svg-icon {
    vertical-align: middle !important;
    width: 26px !important;
    height: 26px !important;
  }

  .el-submenu__title,
  .el-menu-item {
    /* font-size: 24px !important; */
  }

  .menu-wrapper {
    background: #434A54;
    min-height: 97%;
    max-height: 97%;
  }

  .logo {
    display: block;
    height: 130px;
  }

  .logo1 {
    height: 65px;
    margin: 28px 0 0 15px;
  }

  .logo2 {
    width: 250px;
    margin: 0px 0 0 -4px;


  }

  /*  .el-submenu__title,.el-menu-item{
    padding: 0 65px !important;
  }
.el-menu-item{

  }
  .el-submenu .el-menu-item{
    padding: 0 85px !important;
  }

.el-submenu__icon-arrow{
      right: 40px !important;
}
 */
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue